// Intended purposes of the direct bucket uploads (POST /api/upload).
// Shared with the backend: it rejects unknown purposes and applies a per purpose policy (permission, file type,
// size limit, validity). The backend has more purposes (e.g. for admin-menu-v2), only the ones used here are listed.
export const TemporaryFileUploadPurpose = {
  PracticePathRawVideo: "practice-path-raw-video",
  PracticePathFinalVideo: "practice-path-final-video",
} as const;

export type TemporaryFileUploadPurposeString = typeof TemporaryFileUploadPurpose[keyof typeof TemporaryFileUploadPurpose];
